/* eslint-disable */
import UilSearch from '@iconscout/react-unicons/icons/uil-search';
import { Badge, Button, Col, DatePicker, Drawer, Row, Tooltip } from 'antd';
import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { PageHeader } from '../../components/page-headers/page-headers';
import Jobs from './Jobs';
import { useState } from 'react';
import { useEffect } from 'react';
import { jobsReadData, updateJobFilter } from '../../redux/jobs/actionCreator';
import Filters from './Filters';
import { FilterOutlined } from '@ant-design/icons';
import Heading from '../../components/heading/heading';
import { logisticCondition } from './AddEditJob';
import { useSearchParams } from 'react-router-dom';


function LogisticsJob(props) {
    const dispatch = useDispatch();
    const { jobs, filters } = useSelector((state) => state.jobs);
    const [search, setSearch] = useState("");
    const [dateRange, updateRange] = useState([]);
    const [showFilters, updateShowFilters] = useState();
    const [searchParams] = useSearchParams();

    const updateFilters = (newFilters) => dispatch(updateJobFilter(newFilters));

    const applyMoreFilter = (newFilters) => {
        updateFilters({ ...filters, ...newFilters });
        updateShowFilters(false);
    };

    const isFilterApplied = useCallback(() => {
        let isApplied = false;

        if (!filters) {
            return isApplied
        }

        Object.keys(filters).forEach(key => {
            if (filters[key] && filters[key].length) {
                isApplied = true;
            }
        })
        return isApplied;
    }, [filters]);

    const applyFilter = () => {
        getJobs({ startDate: dateRange?.[0]?.toISOString(), endDate: dateRange?.[1].endOf('day')?.toISOString() })
    }

    const onHandleSearch = (e) => {
        setSearch(e.target.value);
    };

    const getJobs = (filter = {}) => {
        filter.targetPorts = filter.targetPorts ? filter.targetPorts : [];
        filter.targetPorts = [...filter.targetPorts, ...logisticCondition];
        dispatch(jobsReadData(6, search, false, { ...filter, ...filters, }, false, '', searchParams.get('size') ?? 100, parseInt(searchParams.get('page') ?? 1) - 1))
    }

    useEffect(() => {
        getJobs()
    }, [dispatch, search, filters, props.isPrepared, searchParams]);

    useEffect(() => {
        if (!dateRange) {
            getJobs();
        }
    }, [dateRange])


    return (
        <div>
            <PageHeader
                className="flex items-center justify-between bg-transparent [&>div>div>.ant-page-header-heading-title]:text-[22px] [&>div>div>.ant-page-header-heading-title]:font-semibold [&>div>div>.ant-page-header-heading-title]:text-dark dark:[&>div>div>.ant-page-header-heading-title]:text-white leading-[32px] [&>div>div]:flex [&>div>div]:items-center gap-[6px] [&>div]:flex [&>div]:flex-wrap [&>div]:items-center [&>div]:w-full [&>div]:gap-[10px] [&>div>.ant-page-header-heading-left]:m-0 [&>div>.ant-page-header-heading-left]:gap-[1px]"
                subTitle={<div className='flex items-center gap-2'>
                    <Heading className="text-[17px] mb-0">{"Logistics"}</Heading>
                    {jobs.length ? <Badge count={jobs.length} status='warning' overflowCount={100000} /> : ''}
                    <DatePicker.RangePicker value={dateRange} onChange={(range) => updateRange(range)} className="border-normal dark:border-white10 " />
                    <Button type='primary' onClick={applyFilter} disabled={!dateRange?.length} >Apply</Button>
                    <Tooltip title={"Click for more Filters"}>
                        <Badge dot={isFilterApplied()} status='warning' title='Filter Applied' >
                            <Button type='ghost' danger={isFilterApplied()} onClick={() => updateShowFilters(true)} icon={<FilterOutlined />} />
                        </Badge>
                    </Tooltip>
                </div>}
                buttons={[
                    <div key={1} className="relative">
                        <span className="absolute left-[18px] top-[50%] translate-y-[-50%]">
                            <UilSearch className="w-[16px] h-[16px] text-light dark:text-white60" />
                        </span>
                        <input
                            className="border-none h-[40px] min-w-[200px] ltr:pl-[45px] ltr:pr-[20px] rtl:pr-[45px] rtl:pl-[20px] rounded-6 bg-white dark:bg-white10 focus-none outline-none"
                            onChange={onHandleSearch}
                            type="text"
                            value={search}
                            name="recored-search"
                            placeholder="Search"
                        />
                    </div>,
                ]}
                ghost
                title=""
            />
            <div className="flex-1 h-auto px-8 xl:px-[15px] pb-[30px] bg-transparent">
                <Row gutter={15}>
                    <Col xs={24}>
                        <div className="bg-white dark:bg-white10 m-0 p-0 text-theme-gray dark:text-white60 text-[15px] rounded-10 relative mb-[25px]">
                            <Jobs variant={'invoiceSent'} navigateBack={true} />
                        </div>
                    </Col>
                </Row>
            </div>

            <Drawer title={"Filters"} open={showFilters} onClose={() => updateShowFilters(false)}>
                <Filters onApply={applyMoreFilter} filter={filters} hideJobDescription={true} />
            </Drawer>
        </div>
    );
}

export default LogisticsJob;
